export default __webpack_public_path__ + "static/media/rotare.2fea14af.svg";